import { useTranslation } from 'next-i18next';
export const FeaturedEmpty = () => {
  const {
    t
  } = useTranslation(['common']);
  return <div className={'flex flex-col items-center justify-center gap-sm self-stretch px-xs py-xl'} data-sentry-component="FeaturedEmpty" data-sentry-source-file="FeaturedEmpty.tsx">
      <div>
        <img className={'size-[34px]'} src="/assets/empty_question.png" alt="empty_question" />
      </div>
      <div className={'flex flex-col items-center justify-center gap-3xs'}>
        <span className={'text-heading-sm-bold text-alternative'}>
          {t('common:featured.empty.title')}
        </span>
        <span className={'text-body-md-medium text-assistive'}>
          {t('common:featured.empty.description')}
        </span>
      </div>
    </div>;
};